import type { Height, Width } from "@drone-js/core";
import { PartnerMarketingImages } from "libs/images/partnerMarketing";
import type { IBrandLogo } from "../BrandLogo";

export enum BrandName {
    Agoda = "agoda",
    Priceline = "priceline",
    Kayak = "kayak",
    BCom = "booking-com",
    OpenTable = "open-table",
}

export type BrandsInfoType = {
    [key in BrandName]: IBrandLogo;
};

const BRAND_DIMENSIONS: Record<BrandName, { width: Width; height: Height }> = {
    [BrandName.Agoda]: { width: "80px", height: "40.75px" },
    [BrandName.Priceline]: { width: "114px", height: "27.23px" },
    [BrandName.Kayak]: { width: "114px", height: "21.38px" },
    [BrandName.BCom]: { width: "114px", height: "18.97px" },
    [BrandName.OpenTable]: { width: "114px", height: "25.3px" },
};

const createBrandInfo = (brand: BrandName, src: string): IBrandLogo => ({
    src,
    alt: brand,
    ...BRAND_DIMENSIONS[brand],
});

const brandList: BrandsInfoType = {
    [BrandName.Agoda]: createBrandInfo(BrandName.Agoda, PartnerMarketingImages.Agoda),
    [BrandName.Priceline]: createBrandInfo(BrandName.Priceline, PartnerMarketingImages.Priceline),
    [BrandName.Kayak]: createBrandInfo(BrandName.Kayak, PartnerMarketingImages.Kayak),
    [BrandName.BCom]: createBrandInfo(BrandName.BCom, PartnerMarketingImages.BCom),
    [BrandName.OpenTable]: createBrandInfo(BrandName.OpenTable, PartnerMarketingImages.OpenTable),
};

export const brandArray: IBrandLogo[] = Object.values(brandList);
